import { ToggleLanguage } from "components/UI/Toggle/ToggleLanguage";
import { CardComponent } from "containers/Card/CardComponent";
import { CardAsyncComponent } from "containers/CardAsync/CardAsyncComponent";
import { CardDynamicComponent } from "containers/CardDynamic/CardDynamic";
import { CardSubscriptionDynamicComponent } from "containers/CardSubscriptionDynamic/CardSubscriptionDynamic";
import { CashComponent } from "containers/Cash/CashComponent";
import { PayoutsCashComponent } from "containers/PayoutsCash/PayoutsCashComponent";
import { TransferComponent } from "containers/Transfer/TransferComponent";
import { remove, union } from "lodash";
import * as React from "react";
import { Translate } from "react-localize-redux";
import { Redirect, Route } from "react-router-dom";
import { CountryEnum } from "root/shared/CountryEnum";
import { CurrencyEnum } from "root/shared/CurrencyEnum";
import { IconsPaymentMethods } from "root/shared/IconsPaymentMethods";
import { PaymenMethodEnum } from "root/shared/PaymenMethodEnum";
import { getCashIcon, getTransferIcon } from "root/shared/Utility";
import "./assets/css/selector.css";
import "./assets/css/tabs.css";

type IContainer = {
  iClass: string;
  component: React.ComponentClass;
  jsx: React.ReactNode;
};
const credit_card_string: string = "credit-card";
const CONTAINERS: { [key: string]: IContainer } = {
  card: {
    iClass: IconsPaymentMethods.card,
    component: CardComponent,
    jsx: <CardComponent />,
  },
  credit_card: {
    iClass: IconsPaymentMethods.card,
    component: CardComponent,
    jsx: <CardComponent />,
  },
  debit_card: {
    iClass: IconsPaymentMethods.card,
    component: CardComponent,
    jsx: <CardComponent />,
  },
  transfer: {
    iClass: IconsPaymentMethods.transfer,
    component: TransferComponent,
    jsx: <TransferComponent />,
  },
  cash: {
    iClass: IconsPaymentMethods.cash,
    component: CashComponent,
    jsx: <CashComponent />,
  },
  payouts_cash: {
    iClass: IconsPaymentMethods.payouts_cash,
    component: PayoutsCashComponent,
    jsx: <PayoutsCashComponent />,
  },
  card_dynamic: {
    iClass: IconsPaymentMethods.card_dynamic,
    component: CardDynamicComponent,
    jsx: <CardDynamicComponent />,
  },
  card_async: {
    iClass: IconsPaymentMethods.card_async,
    component: CardAsyncComponent,
    jsx: <CardAsyncComponent />,
  },
  card_subscription_dynamic: {
    iClass: IconsPaymentMethods.card_subscription_dynamic,
    component: CardSubscriptionDynamicComponent,
    jsx: <CardSubscriptionDynamicComponent />,
  },
};

type IContainerItem = IContainer & {
  id: string;
  route: string;
};

interface IToggleContainerState {
  selected: string;
  selectorOpen: boolean;
  selectorSelected: string;
  transferType: string;
  elements: IContainerItem[];
}

/**
 * Navigation Stateful Component
 */
class NavigationComponent extends React.Component<
  {
    components: string[];
    currency: string;
    isSubscription: boolean;
    country: string;
  },
  IToggleContainerState
> {
  constructor(props: {
    components: string[];
    currency: string;
    isSubscription: boolean;
    country: string;
  }) {
    super(props);
    this._handleSelectorClick = this._handleSelectorClick.bind(this);
    this._getIcon = this._getIcon.bind(this);

    const selectorOpen: boolean = false;
    const containers: string[] = Object.keys(CONTAINERS);
    const components: string[] = this._validateComponents(
      this.props.components
    );

    const elements: IContainerItem[] = components
      .map((name: string) => (name === "credit-card" ? "card" : name))
      .filter(
        (prop: string, index: number, arr: string[]) =>
          arr.indexOf(prop) === index && containers.includes(prop)
      )
      .map((id: string) => ({
        ...CONTAINERS[id],
        id,
        route: `/${id}`,
      }));

    const transferType: string = this.props.components.includes("transfer")
      ? this._getTransferType(props.currency)
      : "";

    this.state = {
      elements,
      selectorOpen,
      transferType,
      selectorSelected: "",
      selected: elements.length !== 0 ? elements[0].id : "",
    };
  }

  public render(): React.ReactNode {
    let toRender: React.ReactNode;
    const toggle_class: string = "translate-toggle-as-item";

    switch (this.state.elements.length) {
      case 0:
        toRender = (
          <div>
            <div className="selected-method-one d-flex justify-content-center align-items-center">
              <div className="title d-flex align-items-center justify-content-center px-4 py-3">
                <div className={`${this.state.selected}-icon mr-2`} />
                <Translate
                  id={`${this._getPaymentMethodTitle(this.state.selected)}`}
                />
              </div>
            </div>
            <div className={toggle_class}>
              <ToggleLanguage />
            </div>
            <div id="TestIdW" className="box-content p-3">
              <CardComponent />
            </div>
          </div>
        );
        break;
      case 1:
        toRender = (
          <div>
            <div className="selected-method-one d-flex justify-content-center align-items-center">
              <div className="title d-flex align-items-center justify-content-center px-4 py-3">
                <div className={`${this.state.selected}-icon mr-2`} />
                <Translate
                  id={`${this._getPaymentMethodTitle(this.state.selected)}`}
                />
              </div>
            </div>
            <div id="TestIdS" className="box-content p-3">
              {CONTAINERS[this.state.elements[0].id].jsx}
            </div>
          </div>
        );
        break;
      default:
        let redirect: JSX.Element = (
          <Redirect to={`${this.state.elements[0].route}`} exact={true} />
        );
        const activeElement:
          | IContainerItem
          | undefined = this.state.elements.find(
          (element: IContainerItem) => element.id === this.state.selected
        );

        // istanbul ignore else
        if (activeElement !== undefined)
          redirect = <Redirect to={`${activeElement.route}`} exact={true} />;

        toRender = (
          <section
            className={
              this.state.selectorOpen ? "main selector-active" : "main"
            }
          >
            {this._selectorTitle(this.state.selectorOpen)}

            <div className="method-content">
              <div className="pt-3 px-3 pb-1">
                {this.state.elements.map(
                  (elem: IContainerItem, index: number) => (
                    <Route
                      key={index}
                      path={elem.route}
                      component={elem.component}
                    />
                  )
                )}
                {redirect}
              </div>

              <div className="method-selector d-flex flex-column justify-content-between p-4">
                <div>
                  {this.state.elements.map((elem: IContainerItem) => (
                    <a
                      key={elem.id}
                      onClick={this._handleSelectorClick.bind(this, elem.id)}
                      className={`${this._getIcon(elem.id)} ${
                        elem.id === this.state.selectorSelected
                          ? "selected"
                          : ""
                      }`}
                    >
                      <div className={`${elem.iClass}-black mr-3`} />
                      <div className="method d-flex flex-column flex-grow-1">
                        <Translate
                          id={`${this._getPaymentMethodTitle(elem.id)}`}
                        />
                      </div>
                      {elem.id === PaymenMethodEnum.CARD_ASYNC &&
                      this.props.isSubscription ? (
                        <div
                          className={`${elem.iClass}-subscription-end ml-3`}
                        />
                      ) : (
                        <div className={`${elem.iClass}-end ml-3`} />
                      )}
                    </a>
                  ))}
                </div>
                <div className="d-flex align-items-center justify-content-center mt-3">
                  <ToggleLanguage />
                </div>
              </div>
            </div>
          </section>
        );
        break;
    }

    return toRender;
  }

  private _selectorTitle(selectorOpen: boolean): JSX.Element {
    if (selectorOpen)
      return (
        <div
          className={
            "selected-method-open-selector d-flex align-items-center justify-content-center px-4 py-3"
          }
        >
          <div className="title">
            <Translate id="selectPaymentMethod" />
          </div>
        </div>
      );

    return (
      <div className="selected-method d-flex align-items-center">
        <div className="title selected-method-title d-flex align-items-center px-4 py-3">
          <div className={`${this.state.selected}-icon mr-2`} />
          <Translate
            id={`${this._getPaymentMethodTitle(this.state.selected)}`}
          />
        </div>

        <div className="open-method-selector-tab px-4 py-3">
          <a
            onClick={(): void => this._openSelector()}
            className="open-method-selector"
          >
            <div>
              <Translate id="changePaymentMethod" />
            </div>
          </a>
        </div>
      </div>
    );
  }

  private _openSelector(): void {
    this.setState<"selectorOpen">({
      selectorOpen: true,
    });
  }

  private _handleSelectorClick(id: string): void {
    this.setState({
      selectorSelected: id,
    });

    setTimeout(() => {
      this.setState({
        selected: id,
        selectorSelected: "",
        selectorOpen: false,
      });
    }, 300);
  }

  private _getTransferType(currency: string): string {
    switch (currency) {
      case "COP":
        return "Colombia";
      case "MXN":
        return "Mexico";
      case "CLP":
        return "Chile";
      case "PEN":
        return "Peru";
      default:
        return "";
    }
  }

  private _validateComponents(componentsAux: string[]): string[] {
    let components: string[] = componentsAux;

    if (
      components.includes(PaymenMethodEnum.CARD) &&
      this.props.currency === CurrencyEnum.COP
    ) {
      remove(
        components,
        (name: string): boolean => name === PaymenMethodEnum.CARD
      );
      remove(
        components,
        (name: string): boolean => name === PaymenMethodEnum.CREDIT_CARD
      );
      remove(
        components,
        (name: string): boolean => name === PaymenMethodEnum.DEBIT_CARD
      );
      components = union(
        [PaymenMethodEnum.CREDIT_CARD, PaymenMethodEnum.DEBIT_CARD],
        components
      );
    }

    if (
      components.includes(credit_card_string) &&
      this.props.currency === CurrencyEnum.COP
    ) {
      remove(
        components,
        (name: string): boolean => name === credit_card_string
      );
      remove(
        components,
        (name: string): boolean => name === PaymenMethodEnum.CREDIT_CARD
      );
      remove(
        components,
        (name: string): boolean => name === PaymenMethodEnum.DEBIT_CARD
      );
      components = union(
        [PaymenMethodEnum.CREDIT_CARD, PaymenMethodEnum.DEBIT_CARD],
        components
      );
    }

    return components;
  }

  private _getIcon(elementId: string): string {
    switch (elementId) {
      case "transfer": {
        return getTransferIcon(this.props.currency);
      }
      case "cash": {
        return getCashIcon(this.props.currency);
      }
      default:
        return elementId;
    }
  }

  private _getPaymentMethodTitle(paymentMethod: string): string {
    switch (paymentMethod) {
      case PaymenMethodEnum.CARD:
        if (this.props.country === CountryEnum.CL)
          return "selectorMethods.credit_card";

        return "selectorMethods.card";
      case PaymenMethodEnum.CREDIT_CARD:
        return "selectorMethods.credit_card";
      case PaymenMethodEnum.DEBIT_CARD:
        return "selectorMethods.debit_card";
      case PaymenMethodEnum.TRANSFER:
        if (this.props.country === CountryEnum.MX)
          return "selectorMethods.transfer_mxn";
        if (this.props.isSubscription)
          return "selectorMethods.transfer_subscription";

        return "selectorMethods.transfer";
      case PaymenMethodEnum.CASH:
        return "selectorMethods.cash";
      case PaymenMethodEnum.PAYOUTS_CASH:
        return "selectorMethods.payouts_cash";
      case PaymenMethodEnum.CARD_ASYNC:
        if (this.props.isSubscription)
          return "selectorMethods.card_subscription_async";

        return "selectorMethods.card_async";
      case PaymenMethodEnum.CARD_DYNAMIC:
        if (this.props.isSubscription)
          return "selectorMethods.card_subscription_dynamic";

        return "selectorMethods.card_dynamic";
      case PaymenMethodEnum.CARD_SUBSCRIPTION_DYNAMIC:
        return "selectorMethods.card_subscription_dynamic";
      default:
        return "";
    }
  }
}

export { NavigationComponent };



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationComponent.tsx